import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { AdjustMonthDrawer } from "./AdjustMonthDrawer";

export const ContractManage = () => {

    return (
        <>
            <PageHeader />
            <DataBox />
            <AdjustMonthDrawer />
        </>
    )
}